/**
 * Legacy code. W wersji ts zastepowany przez adnotacje @VModel.
 * Do usuniecia po przepisaniu autocompletow na ts.
 */
export default {
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  }
};
